'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnSunsetPhaseBunja } from '@flipster/features/src/flipster-earn/sunset/phase-bunja';
import { earnSummaryBunja, getEarnSummaryOfCurrency } from '@flipster/features/src/shared/earn/state';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { hstack, stack, vstack } from '@flipster/styled-system/patterns';
import { isEarnSunsetProductCurrency } from '@flipster/utils/earn-sunset';

import { InactiveAprCard } from './inactive-apr-card';

export const BeforeParticipationEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const { isFlipsterEarnHiddenAtom } = useBunja(earnSunsetPhaseBunja);
  const earnSummary = useAtomValue(earnSummaryAtom);
  const isFlipsterEarnHidden = useAtomValue(isFlipsterEarnHiddenAtom);

  const sortedCurrencies = earnSummary?.currencies
    .filter((c) => !(isFlipsterEarnHidden && isEarnSunsetProductCurrency(c.currency)))
    .sort((a, b) => {
      const aMaxAprPct = getEarnSummaryOfCurrency(a.currency, earnSummary).maxAprPct;
      const bMaxAprPct = getEarnSummaryOfCurrency(b.currency, earnSummary).maxAprPct;
      return bMaxAprPct.minus(aMaxAprPct).toNumber();
    });

  return (
    <section className={stack({ gap: 20 })}>
      <div className={hstack({ justify: 'space-between' })}>
        <div className={stack({ gap: 4 })}>
          <p className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Deposit_and_start_earning' />
          </p>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
            <FormattedMessage id='Autogen_common.r251126.s_Earn_and_trade_seamlessly_Grow_your_balance_while_you_trade' />
          </p>
        </div>
      </div>
      <div className={vstack({ alignItems: 'stretch', gap: 10 })}>
        {sortedCurrencies?.map((c) => <InactiveAprCard key={c.currency} currency={c.currency} />)}
      </div>
    </section>
  );
};
